module.exports = __webpack_public_path__ + "static/img/2808_phase_function_Paper_PointsHejduk_Prediction.176c16d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/2808_phase_function_Paper_PointsHejduk_Prediction.png
// module id = YltT
// module chunks = 0